<button mat-button [style.color]="couleur" class="ion-text-center centrer" (click)="fermer()">
  <mat-icon>{{icone}}</mat-icon>
  <span class="bold">{{message}}</span>
</button>